// pages/Admin/AdminHome.jsx
import { Card, Row, Col, Typography } from "antd";
import {
  ShopOutlined,
  AppstoreOutlined,
  DeploymentUnitOutlined,
  ApartmentOutlined,
  UserOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

import "./AdminHome.css";

const { Title, Text } = Typography;

function AdminHome() {
  const cards = [
    {
      title: "User Management",
      icon: <UserOutlined />,
      desc: "Manage platform users, roles and access permissions",
      color: "#6366f1",
    },
    {
      title: "Commercial Approvals",
      icon: <ShopOutlined />,
      desc: "Review and approve commercial space listings",
      color: "#3b82f6",
    },
    {
      title: "Stall Approvals",
      icon: <AppstoreOutlined />,
      desc: "Process stall registration requests",
      color: "#10b981",
    },
    {
      title: "Franchise Approvals",
      icon: <DeploymentUnitOutlined />,
      desc: "Evaluate franchise applications",
      color: "#f59e0b",
    },
    {
      title: "Business Approvals",
      icon: <ApartmentOutlined />,
      desc: "Verify business entity registrations",
      color: "#8b5cf6",
    },
    {
      title: "Ad Management",
      icon: <FileTextOutlined />,
      desc: "Review and moderate advertisement campaigns",
      color: "#06b6d4",
    },
  ];

  return (
    <div className="admin-home">
      {/* Header */}
      <div className="admin-header">
        <div className="admin-header__content">
          <Title level={3} className="admin-title">
            Administration Hub
          </Title>
          <Text className="admin-subtitle">
            Centralized management console for platform oversight
          </Text>
        </div>
      </div>

      {/* Cards Grid
          xs={24}  →  1 column  (≤575px)
          sm={12}  →  2 columns (576px–767px)
          md={12}  →  2 columns (768px–991px)
          lg={8}   →  3 columns (≥992px)
      */}
      <Row gutter={[20, 20]} className="admin-grid">
        {cards.map((card, index) => (
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            key={index}
          >
            <Card hoverable className="admin-card">
              <div
                className="icon-box"
                style={{ backgroundColor: `${card.color}15` }}
              >
                <span style={{ color: card.color, display: "flex", alignItems: "center" }}>
                  {card.icon}
                </span>
              </div>

              <div className="card-content">
                <Title level={5} className="card-title">
                  {card.title}
                </Title>
                <Text className="card-desc">{card.desc}</Text>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default AdminHome;